module.exports = __webpack_public_path__ + "img/pending.e026ea26.svg";